var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteReseller(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3640_9850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3640_9850",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00683594,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3640_9850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13.5068C17.4667 13.5068 17.646 13.4358 17.788 13.2938C17.9293 13.1525 18 12.9735 18 12.7568C18 12.5402 17.9293 12.3608 17.788 12.2188C17.646 12.0775 17.4667 12.0068 17.25 12.0068H14.75C14.5333 12.0068 14.3543 12.0775 14.213 12.2188C14.071 12.3608 14 12.5402 14 12.7568C14 12.9735 14.071 13.1525 14.213 13.2938C14.3543 13.4358 14.5333 13.5068 14.75 13.5068H17.25ZM17.25 16.5068C17.4667 16.5068 17.646 16.4362 17.788 16.2948C17.9293 16.1528 18 15.9735 18 15.7568C18 15.5402 17.9293 15.3608 17.788 15.2188C17.646 15.0775 17.4667 15.0068 17.25 15.0068H14.75C14.5333 15.0068 14.3543 15.0775 14.213 15.2188C14.071 15.3608 14 15.5402 14 15.7568C14 15.9735 14.071 16.1528 14.213 16.2948C14.3543 16.4362 14.5333 16.5068 14.75 16.5068H17.25ZM15 7.00684H20C20.55 7.00684 21.021 7.2025 21.413 7.59384C21.8043 7.98584 22 8.45684 22 9.00684V20.0068C22 20.5568 21.8043 21.0278 21.413 21.4198C21.021 21.8112 20.55 22.0068 20 22.0068H4C3.45 22.0068 2.97933 21.8112 2.588 21.4198C2.196 21.0278 2 20.5568 2 20.0068V9.00684C2 8.45684 2.196 7.98584 2.588 7.59384C2.97933 7.2025 3.45 7.00684 4 7.00684H9V4.00684C9 3.45684 9.196 2.98584 9.588 2.59384C9.97933 2.2025 10.45 2.00684 11 2.00684H13C13.55 2.00684 14.021 2.2025 14.413 2.59384C14.8043 2.98584 15 3.45684 15 4.00684V7.00684ZM11 9.00684H13V4.00684H11V9.00684ZM9 15.0068C9.41667 15.0068 9.77067 14.8608 10.062 14.5688C10.354 14.2775 10.5 13.9235 10.5 13.5068C10.5 13.0902 10.354 12.7362 10.062 12.4448C9.77067 12.1528 9.41667 12.0068 9 12.0068C8.58333 12.0068 8.22933 12.1528 7.938 12.4448C7.646 12.7362 7.5 13.0902 7.5 13.5068C7.5 13.9235 7.646 14.2775 7.938 14.5688C8.22933 14.8608 8.58333 15.0068 9 15.0068ZM6 18.0068H12V17.5568C12 17.2735 11.9207 17.0108 11.762 16.7688C11.604 16.5275 11.3833 16.3402 11.1 16.2068C10.7667 16.0568 10.4293 15.9445 10.088 15.8698C9.746 15.7945 9.38333 15.7568 9 15.7568C8.61667 15.7568 8.25433 15.7945 7.913 15.8698C7.571 15.9445 7.23333 16.0568 6.9 16.2068C6.61667 16.3402 6.396 16.5275 6.238 16.7688C6.07933 17.0108 6 17.2735 6 17.5568V18.0068Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3640_9850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00683594)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteReseller);
export default __webpack_public_path__ + "static/media/invite_reseller.c18bec61d1bed74584416d606b3bc5e4.svg";
export { ForwardRef as ReactComponent };